import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { first, firstValueFrom } from 'rxjs';
import { TagsApiService } from '../apis/tags-api.service';
import { DottedDropdownAction } from '../dotted-dropdown/dotted-dropdown.component';
import { LocalStorageService } from '../lib/local-storage.service';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { ReservationTag } from '../model/reservation-tag';

declare let $: any;

@Component({
  selector: 'app-dietary-tags',
  templateUrl: './dietary-tags.component.html',
  styleUrls: ['./dietary-tags.component.scss']
})
export class DietaryTagsComponent implements OnInit {

  public data: ReservationTag[] = [
    { id: "1", title: 'Allergy: Fish', categoryId: "" },
    { id: "2", title: 'Allergy: Dairy', categoryId: "" },
    { id: "3", title: 'Allergy: Nuts', categoryId: "" },
    { id: "4", title: 'Allergy: Shells', categoryId: "" },
    { id: "5", title: 'Diet: Vegan', categoryId: "" },
    { id: "6", title: 'Diet: Vegetarian', categoryId: "" }
  ];

  @ViewChild('modal') modal!: ModalDialogComponent;
  @ViewChild('deleteModal') deleteModal!: ModalDialogComponent;

  search: string = "";
  selectedTag: ReservationTag = new ReservationTag();

  public actions: DottedDropdownAction[] = [];

  showDeleteModal(context: ReservationTag) {
    this.selectedTag = { ...context };
    this.deleteModal.show();
  }

  showAddModal() {
    this.selectedTag = new ReservationTag();
    this.modal.show();
  }

  editTag(context: ReservationTag): void {
    this.selectedTag = { ...context };
    this.modal.show();
  }

  clearSearch() {
    this.search = "";
  }

  modalClosed(updates: ReservationTag): void {
    const existing = this.data.find(i => i.id == this.selectedTag.id);

    if (existing == null) {
      this.data.push({ ...this.selectedTag });
    } else {
      existing!.title = this.selectedTag.title;
    }
  }

  deleteModalClosed(ok: boolean) {
    if (ok == false) {
      return;
    }

    const existing = this.data.findIndex(i => i.id == this.selectedTag.id);
    this.data.splice(existing, 1);
  }

  constructor(
    private translate: TranslateService,
    private tagsApi: TagsApiService,
    private localStorageService: LocalStorageService) {

  }

  ngOnInit(): void {
    this.loadActions();
    this.tagsApi
      .getAllTags(parseInt(this.localStorageService.getRestaurantId() + ""))
      .pipe(first())
      .subscribe((resp) => {
        console.log(resp);
      });
  }

  loadActions = async () => {
    const justToLoadTranslations = await firstValueFrom(this.translate.get('report.status.completed'));
    this.actions = [
      { name: this.translate.instant('common.buttons.edit'), color: 'default', action: (context: ReservationTag) => this.editTag(context) },
      { name: this.translate.instant('common.buttons.delete'), color: 'danger', action: (context: ReservationTag) => this.showDeleteModal(context) }
    ];
  }

}
